import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {}

const initialState: UserState = {};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
});

export default userSlice.reducer;
